import { MatDialogConfig } from '@angular/material/dialog';
import { SharedDialogOpenOptions } from '../models/shared-dialog-open-options';

/**
 * Converts {@link SharedDialogOpenOptions} into a plain {@link MatDialogConfig} for
 * {@link MatDialog.open}.
 *
 * Copies only supported fields so wrapper-only keys (e.g. `matConfigOverride`) are not
 * passed through as unknown properties. `matConfigOverride` is spread last so callers can
 * override any mapped value with raw Material options when needed.
 */
export function mapSharedDialogOptionsToMatConfig<TData = unknown>(
    options: SharedDialogOpenOptions<TData>
): MatDialogConfig<TData> {
    return {
        data: options.data,
        width: options.width,
        minWidth: options.minWidth,
        maxWidth: options.maxWidth,
        height: options.height,
        minHeight: options.minHeight,
        maxHeight: options.maxHeight,
        disableClose: options.disableClose,
        hasBackdrop: options.hasBackdrop,
        autoFocus: options.autoFocus,
        restoreFocus: options.restoreFocus,
        closeOnNavigation: options.closeOnNavigation,
        panelClass: options.panelClass,
        backdropClass: options.backdropClass,
        ariaLabel: options.ariaLabel,
        ariaLabelledBy: options.ariaLabelledBy,
        ariaDescribedBy: options.ariaDescribedBy,
        enterAnimationDuration: options.enterAnimationDuration,
        exitAnimationDuration: options.exitAnimationDuration,
        ...options.matConfigOverride,
    };
}
